/**
 * LAWSON PARIS - Quiz de Recommandation de Parfums
 * Version 3.1 - MODIFICATIONS CLIENT
 * 
 * Nouveautés V3.1 (16 novembre 2025) :
 * - Suppression questions 12, 13, 14, 17 (de 17 à 13 questions)
 * - Q4 modifiée : "Ville souhaitée" avec Paris, New York, Montréal, Londres, Rio, Kinshasa
 * - Logo LAWSON PARIS ajouté en haut du quiz
 * - Mise à jour des mappings et poids
 * - Ajustement boost NAKO (suppression référence café)
 * 
 * Base V3.0 :
 * - Correction bug tests 3-4 (ICÔNE)
 * - Logs détaillés par question
 * - Fix bug fermeture modal
 * - Exclusion RARE/ICÔNE si homme
 * - Room sprays toujours éligibles
 * - Règle absolue vanille + crème vanille → NAKO
 * - Boost massif NAKO pour combo vanille
 */

// Configuration des questions
const quizData = {
  // Question initiale
  initialQuestion: {
    id: 'purpose',
    text: 'Pour qui faites-vous ce choix ?',
    options: [
      { value: 'me', label: 'Pour moi' },
      { value: 'gift', label: 'Pour offrir' },
      { value: 'home', label: 'Pour ma maison / bureau' },
      { value: 'unsure', label: 'Je ne sais pas encore' }
    ]
  },

  // 17 questions principales
  questions: [
    {
      id: 1,
      text: 'Tranche d\'âge :',
      options: [
        { value: '18-25', label: '18–25 ans', scores: { rare: 2, hybride: 1 } },
        { value: '26-35', label: '26–35 ans', scores: { icone: 1, hybride: 2, nako: 1 } },
        { value: '36-45', label: '36–45 ans', scores: { icone: 2, nako: 2 } },
        { value: '46-50', label: '46–50 ans', scores: { icone: 1, nako: 2 } },
        { value: 'no-say', label: 'Je préfère ne pas dire', scores: { rich: 1 } }
      ]
    },
    {
      id: 2,
      text: 'Vous êtes :',
      options: [
        { value: 'woman', label: 'Femme', scores: { rare: 1, icone: 1 } },
        { value: 'man', label: 'Homme', scores: { hybride: 1, nako: 2 } },
        { value: 'other', label: 'Autre', scores: { hybride: 1, nako: 1 } },
        { value: 'no-say', label: 'Je préfère ne pas dire', scores: { rich: 1 } }
      ]
    },
    {
      id: 3,
      text: 'Dans la vie, vous êtes plutôt :',
      options: [
        { value: 'student', label: 'Étudiant(e)', scores: { rare: 2 } },
        { value: 'active', label: 'Actif(ve)', scores: { icone: 1, hybride: 1, nako: 1 } },
        { value: 'entrepreneur', label: 'Entrepreneur / indépendant(e)', scores: { icone: 2, hybride: 2 } },
        { value: 'parent', label: 'Parent / vie de famille', scores: { nako: 2 } },
        { value: 'other', label: 'Autre', scores: { rich: 1 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 4,
      text: 'Dans quelle ville souhaiteriez-vous habiter ?',
      options: [
        { value: 'paris', label: 'Paris', scores: { icone: 2, hybride: 1 } },
        { value: 'newyork', label: 'New York', scores: { icone: 2, hybride: 2 } },
        { value: 'montreal', label: 'Montréal', scores: { rare: 1, hybride: 1 } },
        { value: 'london', label: 'Londres', scores: { icone: 1, hybride: 1 } },
        { value: 'rio', label: 'Rio de Janeiro', scores: { rare: 2, itsgiving: 2 } },
        { value: 'kinshasa', label: 'Kinshasa', scores: { nako: 2, marquise: 1 } }
      ]
    },
    {
      id: 5,
      text: 'Vous êtes plutôt :',
      options: [
        { value: 'adventurer', label: 'Aventurier(ère)', scores: { rare: 2, hybride: 1 } },
        { value: 'homebody', label: 'Casanier(ère)', scores: { marquise: 2 } },
        { value: 'festive', label: 'Festif(ve)', scores: { rare: 1, hybride: 1 } },
        { value: 'calm', label: 'Posé(e)', scores: { nako: 2, marquise: 1 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 6,
      text: 'Votre saison préférée :',
      options: [
        { value: 'spring', label: 'Printemps', scores: { rare: 2, hybride: 1, itsgiving: 2 } },
        { value: 'summer', label: 'Été', scores: { rare: 2, itsgiving: 2 } },
        { value: 'autumn', label: 'Automne', scores: { icone: 2, hybride: 1, nako: 2, marquise: 2 } },
        { value: 'winter', label: 'Hiver', scores: { icone: 2, nako: 2, marquise: 2 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 7,
      text: 'Dans votre temps libre, vous préférez :',
      options: [
        { value: 'read', label: 'Lire / regarder un film', scores: { rare: 1, marquise: 1 } },
        { value: 'friends', label: 'Sortir entre amis', scores: { rare: 1, hybride: 1 } },
        { value: 'travel', label: 'Voyager', scores: { rare: 2, hybride: 2 } },
        { value: 'sport', label: 'Faire du sport', scores: { hybride: 2 } },
        { value: 'cook', label: 'Cuisiner', scores: { nako: 1 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 8,
      text: 'Votre caractère :',
      options: [
        { value: 'dynamic', label: 'Dynamique', scores: { hybride: 2, itsgiving: 1 } },
        { value: 'romantic', label: 'Romantique', scores: { rare: 3 } },
        { value: 'discreet', label: 'Discret(ète)', scores: { nako: 1 } },
        { value: 'bold', label: 'Audacieux(se)', scores: { icone: 3, hybride: 1 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 9,
      text: 'Fruit préféré :',
      options: [
        { value: 'strawberry', label: 'Fraise', scores: { rare: 2 } },
        { value: 'peach', label: 'Pêche', scores: { rare: 2 } },
        { value: 'citrus', label: 'Agrumes', scores: { icone: 3 } },
        { value: 'exotic', label: 'Fruits exotiques (mangue, ananas…)', scores: { icone: 3 } },
        { value: 'red-fruits', label: 'Fruits rouges', scores: { rare: 3 } },
        { value: 'vanilla', label: 'Vanille / fève tonka', scores: { nako: 3 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 10,
      text: 'Dessert préféré :',
      options: [
        { value: 'chocolate', label: 'Chocolat', scores: { icone: 2 } },
        { value: 'fruit-tart', label: 'Tarte aux fruits', scores: { rare: 2 } },
        { value: 'ice-cream', label: 'Glace / sorbet', scores: { rare: 1, hybride: 1 } },
        { value: 'tiramisu', label: 'Tiramisu / crème', scores: { icone: 2 } },
        { value: 'macarons', label: 'Macarons', scores: { hybride: 2 } },
        { value: 'vanilla', label: 'Crème vanille / flan', scores: { nako: 1 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 11,
      text: 'Senteur préférée :',
      options: [
        { value: 'fresh', label: 'Fraîche et légère', scores: { rare: 2, hybride: 1, itsgiving: 2 } },
        { value: 'sweet', label: 'Sucrée et gourmande', scores: { rare: 2, marquise: 1 } },
        { value: 'floral', label: 'Florale et romantique', scores: { rare: 3 } },
        { value: 'woody', label: 'Boisée et élégante', scores: { icone: 2, hybride: 2, nako: 2, marquise: 2 } },
        { value: 'oriental', label: 'Orientale et sensuelle', scores: { icone: 3, nako: 3, marquise: 1 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    },
    {
      id: 12,
      text: 'Votre rapport aux parfums :',
      options: [
        { value: 'strong', label: 'J\'aime les parfums forts et affirmés', scores: { icone: 3, nako: 2 } },
        { value: 'soft', label: 'Je préfère les senteurs douces et subtiles', scores: { rare: 3 } },
        { value: 'trail', label: 'J\'aime les parfums qui laissent une empreinte', scores: { icone: 2, nako: 2 } },
        { value: 'change', label: 'J\'aime changer selon mon humeur', scores: { rich: 3 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 2 } }
      ]
    },
    {
      id: 13,
      text: 'Si votre style était une matière :',
      options: [
        { value: 'leather', label: 'Cuir', scores: { icone: 2, nako: 2 } },
        { value: 'linen', label: 'Lin', scores: { rare: 1 } },
        { value: 'silk', label: 'Soie', scores: { icone: 1, nako: 1 } },
        { value: 'velvet', label: 'Velours', scores: { icone: 2 } },
        { value: 'denim', label: 'Jean', scores: { hybride: 2 } },
        { value: 'unsure', label: 'Je ne sais pas', scores: { rich: 1 } }
      ]
    }
  ]
};

// Configuration des parfums - SANS EMOJIS
const perfumes = {
  rare: {
    name: 'Rare',
    tagline: 'Solaire et rayonnant(e)',
    description: 'Rare reflète votre énergie positive, votre romantisme et votre légèreté. Un parfum frais et lumineux qui souligne votre douceur naturelle.',
    image: 'https://lawsonparis.com/cdn/shop/files/F8D58BBE-D7B2-4AD9-852C-4505F7C4FCA5.jpg?v=1764251576&width=990',//'https://lawsonparis.com/cdn/shop/files/Parfum-Lawson-Paris-Rare-3.jpg?v=1750675306&width=533',
    url: `https://lawsonparis.com/products/rare`,
  },
  icone: {
    name: 'Icône',
    tagline: 'Élégante et puissante',
    description: 'Icône affirme votre puissance. Raffinée et magnétique, ce parfum attire tous les regards. Pour les femmes fortes et audacieuses.',
    image: 'https://lawsonparis.com/cdn/shop/files/AB087313-AA68-4CFF-AA54-BC0352405CF3.png?v=1764251311&width=990',//'https://lawsonparis.com/cdn/shop/files/Parfum-Lawson-Paris-Icone-2.jpg?v=1750675424&width=533',
    url: 'https://lawsonparis.com/products/icone'
  },
  hybride: {
    name: 'Hybride',
    tagline: 'Moderne et adaptable',
    description: 'Hybride suit votre rythme intense. Libre et indépendante, cette fragrance casse les codes et s\'adapte à toutes vos facettes.',
    image: 'https://lawsonparis.com/cdn/shop/files/468CA25F-BFE5-44E7-98AC-809A6A29C799.png?v=1764252300&width=990',//'https://lawsonparis.com/cdn/shop/files/Packshot-3.jpg?v=1750671804&width=533',
    url: 'https://lawsonparis.com/products/hybride',
  },
  nako: {
    name: 'Nako',
    tagline: 'Force tranquille et charisme',
    description: 'Parfum mixte, épicé et vanillé. Nako incarne la force tranquille et le charisme naturel. Une signature olfactive puissante et magnétique.',
    image: 'https://lawsonparis.com/cdn/shop/files/49E69521-B624-4785-BCFB-4198490A83F7.jpg?v=1764741299&width=713',
    
    url: 'https://lawsonparis.com/products/nako', 
  },
  rich: {
    name: 'Coffret RICH',
    tagline: 'Pour les curieux et les indécis',
    description: 'Indécis(e) ? Le Coffret RICH vous fait voyager dans plusieurs univers. Idéal pour explorer avant de choisir votre signature olfactive.',
    image: 'https://lawsonparis.com/cdn/shop/files/B90FFDFB-37A3-4B51-8A3E-4ACAB50B0CBD.png?v=1764252037&width=990', //'https://lawsonparis.com/cdn/shop/files/image00005-scaled.jpg?v=1750674353&width=533',
    url: 'https://lawsonparis.com/products/rare-icone-et-hybride-copy-copy',
  },
  marquise: {
    name: 'Room Spray - Marquise',
    tagline: 'Cocooning et chaleureux',
    description: 'Idéal pour vos instants détente. Créez une atmosphère cocooning et chaleureuse à la maison.',
    image: 'https://lawsonparis.com/cdn/shop/files/204E6A70-91C3-45BF-AD6E-01D1553CA547.png?v=1764252399&width=990', //'https://lawsonparis.com/cdn/shop/files/24600B90-D9F7-45CB-9D24-EC3BE16AA278.jpg?v=1759149138&width=533',
    url: 'https://lawsonparis.com/products/marquise',
  },
  itsgiving: {
    name: 'Room Spray - It\'s Giving',
    tagline: 'Frais et polyvalent',
    description: 'Une senteur qui s\'adapte à toutes vos ambiances. Pour les intérieurs frais, aérés et vivants.',
    image: 'https://lawsonparis.com/cdn/shop/files/AF03A022-B531-4B69-A3FC-6A7AA9A0BBF8.jpg?v=1764252494&width=990', //'https://lawsonparis.com/cdn/shop/files/Packshot_05106100-32f8-4844-b0ab-06e8db0d3f8c.png?v=1750672553&width=533',
    url: 'https://lawsonparis.com/products/it-s-giving',
  }
};


// ===================================
// SYSTÈME DE SCORING NORMALISÉ V3.0
// ===================================

// Poids des questions
const QUESTION_WEIGHTS = {
  olfactive_notes: 2.0,
  perfume_relation: 1.8,
  ideal_moment: 1.5,
  character: 1.3,
  season: 1.2,
  age: 1.0,
  gender: 1.0,
  lifestyle: 1.1, //1 //mmo
  personality: 1.0,
  free_time: 1.0,
  style_material: 1.0,
  love_style: 1.0,
  location: 0.7,
  fruit: 1.2, //mmo 0.7,
  dessert: 1.2, //mmo 0.7,
  taste_preference: 0.7,
  drink: 0.7
};

// Mapping question ID → poids
const QUESTION_ID_TO_WEIGHT = {
  1: QUESTION_WEIGHTS.age,
  2: QUESTION_WEIGHTS.gender,
  3: QUESTION_WEIGHTS.lifestyle,
  4: QUESTION_WEIGHTS.location,
  5: QUESTION_WEIGHTS.personality,
  6: QUESTION_WEIGHTS.season,
  7: QUESTION_WEIGHTS.free_time,
  8: QUESTION_WEIGHTS.character,
  9: QUESTION_WEIGHTS.fruit,
  10: QUESTION_WEIGHTS.dessert,
  11: QUESTION_WEIGHTS.olfactive_notes,
  12: QUESTION_WEIGHTS.perfume_relation,
  13: QUESTION_WEIGHTS.style_material
};


// Calculer la somme totale de tous les poids (pour normalisation constante) //mmo new to fix bug Icone
const TOTAL_WEIGHT = Object.values(QUESTION_ID_TO_WEIGHT).reduce((sum, weight) => sum + weight, 0);

// Mapping question ID → catégorie
const QUESTION_TO_CATEGORY = {
  1: 'age',
  2: 'gender',
  3: 'lifestyle',
  4: 'location',
  5: 'personality',
  6: 'season',
  7: 'free_time',
  8: 'character',
  9: 'fruits',
  10: 'dessert',
  11: 'olfactive',
  12: 'perfume_relation',
  13: 'material'
};

// Scores normalisés (0.0 à 1.0)
const NORMALIZED_SCORES = {
  fruits: {
    strawberry: { rare: 0.7 },
    peach: { rare: 0.7 },
    citrus: { icone: 0.9, hybride: 0.7 },
    exotic: { icone: 0.9, hybride: 0.7 },
    'red-fruits': { rare: 1.0, rich: 0.2 },
    vanilla: { nako: 1.0 },
    unsure: { rich: 0.3 }
  },
  character: {
    dynamic: { hybride: 0.8, itsgiving: 0.5 },
    romantic: { rare: 1.0, rich: 0.5 },
    discreet: { nako: 0.7 },
    bold: { icone: 1.0, hybride: 0.5 },
    unsure: { rich: 0.3 }
  },
  olfactive: {
    fresh: { rare: 0.7, hybride: 0.5, itsgiving: 0.7 },
    sweet: { rare: 0.7, marquise: 0.5 },
    floral: { rare: 1.0, rich: 0.45 },
    woody: { icone: 0.7, hybride: 0.7, nako: 0.7, marquise: 0.7 },
    oriental: { icone: 1.0, nako: 1.0, marquise: 0.5 },
    unsure: { rich: 0.3 }
  },
  perfume_relation: {
    strong: { icone: 1.0, nako: 0.7 },
    soft: { rare: 1.0 },
    trail: { icone: 0.8, nako: 0.7 },
    change: { rich: 1.5 },
    unsure: { rich: 0.7 }
  },
  season: {
    spring: { rare: 0.7, hybride: 0.6, itsgiving: 0.7, rich: 0.1 },
    summer: { rare: 0.7, itsgiving: 0.7, rich: 0.1 },
    autumn: { icone: 0.7, hybride: 0.6, nako: 0.7, marquise: 0.7, rich: 0.1 },
    winter: { icone: 0.7, nako: 0.7, marquise: 0.7, rich: 0.1 },
    unsure: { rich: 0.3 }
  },
  age: {
    '18-25': { rare: 0.7, hybride: 0.5, rich: 0.15 },
    '26-35': { icone: 0.7, hybride: 0.8, nako: 0.5, rich: 0.15 },
    '36-45': { icone: 0.8, nako: 0.8, rich: 0.1 },
    '46-50': { icone: 0.5, nako: 0.8, rich: 0.1 },
    'no-say': { rich: 0.3 }
  },
  gender: {
    woman: { rare: 0.5, icone: 0.5 },
    man: { hybride: 0.5, nako: 0.8 },
    other: { hybride: 0.5, nako: 0.5 },
    'no-say': { rich: 0.3 }
  },
  lifestyle: {
    student: { rare: 0.7 },
    active: { icone: 0.5, hybride: 0.5, nako: 0.5, rich: 0.1 },
    entrepreneur: { icone: 0.9, hybride: 0.8 },
    parent: { nako: 0.8 },
    other: { rich: 0.3 },
    unsure: { rich: 0.3 }
  },
  location: {
    paris: { icone: 0.8, hybride: 0.7, rich: 0.15 },
    newyork: { icone: 0.9, hybride: 0.9 },
    montreal: { rare: 0.6, hybride: 0.6 },
    london: { icone: 0.7, hybride: 0.6 },
    rio: { rare: 0.8, itsgiving: 0.8 },
    kinshasa: { nako: 0.8, marquise: 0.6 }
  },
  personality: {
    adventurer: { rare: 0.7, hybride: 0.6, rich: 0.1 },
    homebody: { marquise: 0.8 },
    festive: { rare: 0.5, hybride: 0.5 },
    calm: { nako: 0.8, marquise: 0.5 },
    unsure: { rich: 0.3 }
  },
  free_time: {
    read: { rare: 0.5, marquise: 0.5 },
    friends: { rare: 0.5, hybride: 0.5 },
    travel: { rare: 0.7, hybride: 0.8, rich: 0.15 },
    sport: { hybride: 0.8 },
    cook: { nako: 0.5 },
    unsure: { rich: 0.3 }
  },
  dessert: {
    chocolate: { icone: 1 },
    'fruit-tart': { rare: 0.7 },
    'ice-cream': { rare: 0.5, hybride: 0.5 },
    tiramisu: { icone: 0.7 },
    macarons: { hybride: 0.7 },
    vanilla: { nako: 0.5 },
    unsure: { rich: 0.3 }
  },
  material: {
    leather: { icone: 0.8, nako: 0.8, rich: 0.1 },
    linen: { rare: 0.5, rich: 0.1 },
    silk: { icone: 0.7, nako: 0.5, rich: 0.1 },
    velvet: { icone: 0.8 },
    denim: { hybride: 0.8 },
    unsure: { rich: 0.3 }
  }
};

// Liste de tous les produits
const ALL_PRODUCTS = ['rare', 'icone', 'hybride', 'nako', 'rich', 'marquise', 'itsgiving'];

// Variables globales
let showingInitialQuestion = true;
let currentQuestion = 0;
let userAnswers = {};
let initialAnswer = null;
let scores = {
  rare: 0,
  icone: 0,
  hybride: 0,
  nako: 0,
  rich: 0,
  marquise: 0,
  itsgiving: 0
};

// Initialisation du quiz
function initQuiz() {
  createQuizModal();
  addQuizButtonToHomepage(); //mmo reactivate on wednesday 03/12/2025
}

// Créer la structure HTML de la modale
function createQuizModal() {
  const logoBase64 = `data:image/webp;base64,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`;
  const modalHTML = `
    <div id="lawson-quiz-overlay" class="lawson-quiz-overlay">
      <div id="lawson-quiz-modal" class="lawson-quiz-modal">
        <button id="lawson-quiz-close" class="lawson-quiz-close">&times;</button>
        
        <div class="lawson-quiz-header">
          <div class="lawson-paris-logo-container">
          <img src="${logoBase64}" alt="LAWSON PARIS" class="lawson-paris-logo">
          </div>
          <h2 class="lawson-quiz-title">Trouvez votre parfum signature</h2>
          <div class="lawson-quiz-progress-container">
            <div id="lawson-quiz-progress" class="lawson-quiz-progress"></div>
          </div>
          <p id="lawson-quiz-step" class="lawson-quiz-step">Question 1 / 13</p>
        </div>
        
        <div id="lawson-quiz-content" class="lawson-quiz-content">
          <!-- Le contenu sera inséré dynamiquement -->
        </div>
        
        <div class="lawson-quiz-navigation">
          <button id="lawson-quiz-prev" class="lawson-quiz-btn lawson-quiz-btn-secondary" style="display: none;">
            ← Précédent
          </button>
          <button id="lawson-quiz-next" class="lawson-quiz-btn lawson-quiz-btn-primary" style="display: none;">
            Suivant →
          </button>
        </div>
      </div>
    </div>
  `;
  
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  
  document.getElementById('lawson-quiz-close').addEventListener('click', handleCloseQuiz);
  document.getElementById('lawson-quiz-overlay').addEventListener('click', function(e) {
    if (e.target === this) handleCloseQuiz();
  });
  document.getElementById('lawson-quiz-prev').addEventListener('click', previousQuestion);
  document.getElementById('lawson-quiz-next').addEventListener('click', nextQuestion);
}

// Gérer la fermeture du quiz
function handleCloseQuiz() {
  // Réinitialiser toutes les variables
  showingInitialQuestion = true;
  currentQuestion = 0;
  userAnswers = {};
  initialAnswer = null;
  scores = {
    rare: 0,
    icone: 0,
    hybride: 0,
    nako: 0,
    rich: 0,
    marquise: 0,
    itsgiving: 0
  };
  
 // Réafficher les éléments de navigation et progress bar
  const navigation = document.querySelector('.lawson-quiz-navigation');
  const progressContainer = document.querySelector('.lawson-quiz-progress-container');
  const stepElement = document.getElementById('lawson-quiz-step');
  
  if (navigation) navigation.style.display = 'flex';
  if (progressContainer) progressContainer.style.display = 'block';
  if (stepElement) stepElement.style.display = 'block';
  
  // Fermer la modale
  document.getElementById('lawson-quiz-overlay').style.display = 'none';
}

// Ajouter le bouton quiz sur la page d'accueil
function addQuizButtonToHomepage() {
  const existingButton = document.getElementById('lawson-quiz-trigger');
  
  if (existingButton) {
    existingButton.addEventListener('click', openQuiz);
    return;
  }
  
  const discoverButton = document.querySelector('a[href*="collections"]');
  
  if (discoverButton && discoverButton.parentElement) {
    const quizButton = document.createElement('button');
    quizButton.id = 'lawson-quiz-trigger';
    quizButton.className = 'lawson-quiz-trigger-btn';
    quizButton.textContent = 'QUIZZ OLFACTIF';
    quizButton.addEventListener('click', openQuiz);
    
    discoverButton.parentElement.insertBefore(quizButton, discoverButton.nextSibling);
  }
}

// Ouvrir le quiz
function openQuiz() {
  // Réinitialiser le quiz
  showingInitialQuestion = true;
  currentQuestion = 0;
  userAnswers = {};
  initialAnswer = null;
  scores = {
    rare: 0,
    icone: 0,
    hybride: 0,
    nako: 0,
    rich: 0,
    marquise: 0,
    itsgiving: 0
  };
    // Réafficher les éléments de navigation et progress bar
  const navigation = document.querySelector('.lawson-quiz-navigation');
  const progressContainer = document.querySelector('.lawson-quiz-progress-container');
  const stepElement = document.getElementById('lawson-quiz-step');
  
  if (navigation) navigation.style.display = 'flex';
  if (progressContainer) progressContainer.style.display = 'block';
  if (stepElement) stepElement.style.display = 'block';
  
  // Afficher la modale et la première question
  document.getElementById('lawson-quiz-overlay').style.display = 'flex';
  showQuestion();
}

// Fermer le quiz (deprecated - use handleCloseQuiz)
function closeQuiz() {
  handleCloseQuiz();
}

// Afficher une question
function showQuestion() {
  const content = document.getElementById('lawson-quiz-content');
  
  if (showingInitialQuestion) {
    const initialQ = quizData.initialQuestion;
    let html = `
      <div class="lawson-quiz-question fade-in">
        <h3 class="lawson-quiz-question-text">${initialQ.text}</h3>
        <div class="lawson-quiz-options">
    `;
    
    initialQ.options.forEach((option) => {
      const isSelected = initialAnswer === option.value;
      html += `
        <button class="lawson-quiz-option ${isSelected ? 'selected' : ''}" 
                data-value="${option.value}"
                data-initial="true">
          <span class="lawson-quiz-option-text">${option.label}</span>
          <span class="lawson-quiz-option-check">✓</span>
        </button>
      `;
    });
    
    html += `
        </div>
      </div>
    `;
    
    content.innerHTML = html;
    
    document.querySelectorAll('.lawson-quiz-option').forEach(option => {
      option.addEventListener('click', selectOption);
    });
    
    updateNavigation();
    updateProgress();
    return;
  }
  
  const question = quizData.questions[currentQuestion];
  let html = `
    <div class="lawson-quiz-question fade-in">
      <h3 class="lawson-quiz-question-text">${question.text}</h3>
      <div class="lawson-quiz-options">
  `;
  
  question.options.forEach((option, index) => {
    const isSelected = userAnswers[currentQuestion] === option.value;
    html += `
      <button class="lawson-quiz-option ${isSelected ? 'selected' : ''}" 
              data-value="${option.value}"
              data-question="${currentQuestion}">
        <span class="lawson-quiz-option-text">${option.label}</span>
        <span class="lawson-quiz-option-check">✓</span>
      </button>
    `;
  });
  
  html += `
      </div>
    </div>
  `;
  
  content.innerHTML = html;
  
  document.querySelectorAll('.lawson-quiz-option').forEach(option => {
    option.addEventListener('click', selectOption);
  });
  
  updateNavigation();
  updateProgress();
}

// Sélectionner une option
function selectOption(e) {
  const button = e.currentTarget;
  const value = button.dataset.value;
  const isInitial = button.dataset.initial === 'true';
  
  document.querySelectorAll('.lawson-quiz-option').forEach(opt => {
    opt.classList.remove('selected');
  });
  
  button.classList.add('selected');
  
  if (isInitial) {
    initialAnswer = value;
    updateNavigation();
    return;
  }
  
  const questionIndex = parseInt(button.dataset.question);
  userAnswers[questionIndex] = value;
  
  updateNavigation();
}

// Question précédente
function previousQuestion() {
  if (currentQuestion === 0) {
    showingInitialQuestion = true;
    showQuestion();
  } else if (currentQuestion > 0) {
    currentQuestion--;
    showQuestion();
  }
}

// Question suivante
function nextQuestion() {
  if (showingInitialQuestion) {
    showingInitialQuestion = false;
    currentQuestion = 0;
    showQuestion();
    return;
  }
  
  if (currentQuestion < quizData.questions.length - 1) {
    currentQuestion++;
    showQuestion();
  } else {
    showResult();
  }
}

// Mettre à jour la navigation
function updateNavigation() {
  const prevBtn = document.getElementById('lawson-quiz-prev');
  const nextBtn = document.getElementById('lawson-quiz-next');
  
  if (showingInitialQuestion) {
    prevBtn.style.display = 'none';
    if (initialAnswer) {
      nextBtn.style.display = 'inline-block';
      nextBtn.textContent = 'Commencer →';
    } else {
      nextBtn.style.display = 'none';
    }
    return;
  }
  
  if (currentQuestion === 0) {
    prevBtn.style.display = 'inline-block';
  } else if (currentQuestion > 0) {
    prevBtn.style.display = 'inline-block';
  } else {
    prevBtn.style.display = 'none';
  }
  
  if (userAnswers[currentQuestion]) {
    nextBtn.style.display = 'inline-block';
    if (currentQuestion === quizData.questions.length - 1) {
      nextBtn.textContent = 'Voir mon résultat';
    } else {
      nextBtn.textContent = 'Suivant →';
    }
  } else {
    nextBtn.style.display = 'none';
  }
}

// Mettre à jour la barre de progression
function updateProgress() {
  if (showingInitialQuestion) {
    document.getElementById('lawson-quiz-progress').style.width = '0%';
    document.getElementById('lawson-quiz-step').textContent = 'Question préliminaire';
    return;
  }
  
  const progress = ((currentQuestion + 1) / quizData.questions.length) * 100;
  document.getElementById('lawson-quiz-progress').style.width = progress + '%';
  document.getElementById('lawson-quiz-step').textContent = `Question ${currentQuestion + 1} / ${quizData.questions.length}`;
}

// Calculer le parfum recommandé - VERSION V3.0
function calculateRecommendation() {
  console.log('\n\n========================================');
  console.log('=== DÉBUT CALCUL RECOMMANDATION V3.1 (13 questions) ===');
  console.log('========================================');
  console.log('Question initiale:', initialAnswer);
  console.log('Réponses utilisateur:', userAnswers);
  console.log(`TOTAL_WEIGHT constant: ${TOTAL_WEIGHT.toFixed(2)}`);

  
  // Vérifier règle absolue NAKO : Q9=vanilla ET Q10=vanilla
  const q9_vanilla = userAnswers[8] === 'vanilla'; // Q9 (index 8)
  const q10_vanilla = userAnswers[9] === 'vanilla'; // Q10 (index 9)
  
  if (q9_vanilla && q10_vanilla) {
    console.log('\n🎯 RÈGLE ABSOLUE ACTIVÉE : Q9=Vanille ET Q10=Crème vanille');
    console.log('→ Recommandation forcée : NAKO');
    console.log('========================================\n');
    return 'nako';
  }
  
  // CAS SPÉCIAL : Si "Pour ma maison/bureau" → UNIQUEMENT room sprays
  if (initialAnswer === 'home') {
    console.log('\n→ Mode ROOM SPRAY EXCLUSIF activé (question initiale = maison/bureau)');
    const roomSprayScores = {
      marquise: 0,
      itsgiving: 0
    };
    
    for (const [qIndexStr, answerValue] of Object.entries(userAnswers)) {
      const qIndex = parseInt(qIndexStr);
      const category = QUESTION_TO_CATEGORY[qIndex + 1]; // +1 car questions commencent à 1
      const weight = QUESTION_ID_TO_WEIGHT[qIndex + 1] || 1.0;
      const scoreMap = NORMALIZED_SCORES[category];
      
      if (scoreMap && scoreMap[answerValue]) {
        const contributions = scoreMap[answerValue];
        for (const product in contributions) {
          if (product === 'marquise' || product === 'itsgiving') {
            roomSprayScores[product] += contributions[product] * weight;
          }
        }
      }
    }
    
      // Normaliser par TOTAL_WEIGHT
    roomSprayScores.marquise /= TOTAL_WEIGHT;
    roomSprayScores.itsgiving /= TOTAL_WEIGHT;
    
    console.log('Scores Room Sprays (normalisés):', roomSprayScores);
    
    if (roomSprayScores.marquise > roomSprayScores.itsgiving) {
      console.log('→ Gagnant: MARQUISE');
      console.log('========================================\n');
      return 'marquise';
    } else if (roomSprayScores.itsgiving > 0) {
      console.log('→ Gagnant: ITS GIVING');
      console.log('========================================\n');
      return 'itsgiving';
    } else {
      console.log('→ Par défaut: MARQUISE');
      console.log('========================================\n');
      return 'marquise';
    }
  }

  //mmo
    // RÈGLE FORCE RICH : Si >= 30% de "je ne sais pas" → RICH automatique
  const totalQuestions = quizData.questions.length; // 17 questions
  const unsureAnswers = ['unsure', 'no-say']; // Toutes les variantes de "je ne sais pas"
  
  let unsureCount = 0;
  for (const answerValue of Object.values(userAnswers)) {
    if (unsureAnswers.includes(answerValue)) {
      unsureCount++;
    }
  }
  
  const unsurePercentage = (unsureCount / totalQuestions) * 100;
  console.log(`\n📊 Analyse indécision: ${unsureCount}/${totalQuestions} réponses "je ne sais pas" (${unsurePercentage.toFixed(1)}%)`);
  
  if (unsurePercentage >= 30) {
    console.log('\n🎯 RÈGLE FORCE RICH ACTIVÉE : >= 30% de "je ne sais pas"');
    console.log('→ Recommandation forcée : COFFRET RICH');
    console.log('========================================\n');
    return 'rich';
  }
  //
  
  // Vérifier si l'utilisateur est un homme (Q2)
  const isMan = userAnswers[1] === 'man'; // Q2 (index 1)
  console.log('\n→ Genre détecté:', isMan ? 'HOMME' : 'FEMME/AUTRE');
  
  // Pour les autres cas : calculer scores normalisés pour TOUS les produits (y compris room sprays)
  const productScores = {};
  const totalWeightUsed = {};
  
  ALL_PRODUCTS.forEach(product => {
    productScores[product] = 0;
    totalWeightUsed[product] = TOTAL_WEIGHT//18.3; //0;//mmo to uncomment
  });
  
  // Calculer les scores pondérés avec logs détaillés
  console.log('\n========================================');
  console.log('=== CALCUL SCORES PONDÉRÉS PAR QUESTION ===');
  console.log('========================================');
  
  for (const [qIndexStr, answerValue] of Object.entries(userAnswers)) {
    const qIndex = parseInt(qIndexStr);
    const qNumber = qIndex + 1; // Numéro de question pour l'affichage
    const category = QUESTION_TO_CATEGORY[qNumber];
    const weight = QUESTION_ID_TO_WEIGHT[qNumber] || 1.0;
    const scoreMap = NORMALIZED_SCORES[category];
    
    console.log(`\nQ${qNumber} (${category}): "${answerValue}" | Poids: ${weight}`);
    
    if (scoreMap && scoreMap[answerValue]) {
      const contributions = scoreMap[answerValue];
      console.log('  Contributions brutes:', contributions);
      
      // Afficher les contributions pondérées
      const weightedContributions = {};
      for (const product in contributions) {
        const value = contributions[product];
        const weighted = value * weight;
        weightedContributions[product] = `+${weighted.toFixed(2)}`;
        productScores[product] += weighted;
        //totalWeightUsed[product] += weight;//mmo test
      }
      console.log('  Contributions pondérées:', weightedContributions);
      
      // Afficher les scores cumulés actuels
      const currentScores = {};
      for (const product of ALL_PRODUCTS) {
        if (productScores[product] > 0) {
          currentScores[product] = productScores[product].toFixed(2);
        }
      }
      console.log('  Scores cumulés:', currentScores);
    } else {
      console.log('  ⚠️ Aucune contribution pour cette réponse');
    }
  }
  
  // Normaliser les scores (diviser par le poids total utilisé)
  console.log('\n========================================');
  console.log('=== NORMALISATION DES SCORES (0-100%) ===');
  console.log('========================================');
  for (const product of ALL_PRODUCTS) {
    if (totalWeightUsed[product] > 0) {
      productScores[product] = productScores[product] / totalWeightUsed[product];
    } else {
      productScores[product] = 0;
    }
    console.log(`${product.toUpperCase().padEnd(10)}: ${(productScores[product] * 100).toFixed(1)}%`);
  }
  
  // EXCLUSION HOMME : Si homme, mettre RARE et ICÔNE à 0
  if (isMan) {
    console.log('\n🚫 EXCLUSION GENRE : Homme détecté');
    console.log('   → RARE mis à 0%');
    console.log('   → ICÔNE mis à 0%');
    productScores.rare = 0;
    productScores.icone = 0;
  }
  
  // BOOST MASSIF NAKO si combo vanille
  const q13_leather = userAnswers[12] === 'leather'; // Q13 (index 12)
  
  if (q9_vanilla && q10_vanilla && q13_leather) {
    console.log('\n⭐ COMBO NAKO PARFAIT DÉTECTÉ !');
    console.log('   Q9: Vanille ✓');
    console.log('   Q10: Crème vanille ✓');
    console.log('   Q13: Cuir ✓');
    console.log('   → Boost MASSIF NAKO : +0.50');
    productScores.nako = (productScores.nako || 0) + 0.50;
  } else if (q9_vanilla || q10_vanilla) {
    console.log('\n⭐ COMBO NAKO PARTIEL DÉTECTÉ !');
    if (q9_vanilla) console.log('   Q9: Vanille ✓');
    if (q10_vanilla) console.log('   Q10: Crème vanille ✓');
  
    let extraBoost = 0.2;
    if (q13_leather) {
      console.log('   Q13: Cuir ✓');
      extraBoost += 0.15;
    }
    
    if (extraBoost > 0) {
      console.log(`   → Boost NAKO : +${extraBoost.toFixed(2)}`);
      productScores.nako = (productScores.nako || 0) + extraBoost;
    }

  }
  //mmo
  // BOOST ICÔNE si agrumes ou fruits exotiques (Q9)
  const q9_citrus = userAnswers[8] === 'citrus'; // Q9 (index 8)
  const q9_exotic = userAnswers[8] === 'exotic';
  
  if (q9_citrus || q9_exotic) {
    console.log('\n⭐ BOOST ICÔNE ACTIVÉ !');
    console.log(`   Q9: ${q9_citrus ? 'Agrumes' : 'Fruits exotiques'} ✓`);
    console.log('   → Boost ICÔNE : +0.2');
    productScores.icone = (productScores.icone || 0) + 0.2;
  }
  
  // BOOST RARE si pêche ou fruits rouges (Q9)
  const q9_peach = userAnswers[8] === 'peach';
  const q9_red_fruits = userAnswers[8] === 'red-fruits';
  
  if (q9_peach || q9_red_fruits) {
    console.log('\n⭐ BOOST RARE ACTIVÉ !');
    console.log(`   Q9: ${q9_peach ? 'Pêche' : 'Fruits rouges'} ✓`);
    console.log('   → Boost RARE : +0.2');
    productScores.rare = (productScores.rare || 0) + 0.2;
  }
  //mmp
  
  // Appliquer les boosts de la question initiale
  console.log('\n========================================');
  console.log('=== APPLICATION BOOSTS QUESTION INITIALE ===');
  console.log('========================================');
  if (initialAnswer) {
    switch(initialAnswer) {
      case 'myself':
      case 'me':
        console.log('Boost "Pour moi" : +15% sur parfums personnels');
        productScores.rare = (productScores.rare || 0) + 0.15;
        productScores.icone = (productScores.icone || 0) + 0.15;
        productScores.hybride = (productScores.hybride || 0) + 0.15;
        productScores.nako = (productScores.nako || 0) + 0.15;
        
        // EXCLUSION HOMME après boost
        if (isMan) {
          console.log('   Mais HOMME détecté → RARE et ICÔNE restent à 0%');
          productScores.rare = 0;
          productScores.icone = 0;
        }
        break;
        
      case 'gift':
        console.log('Boost "Pour offrir" : +35% sur Coffret RICH');
        productScores.rich = (productScores.rich || 0) + 0.35;
        break;
        
      case 'unsure':
        console.log('Boost "Je ne sais pas" : +20% sur Coffret RICH');
        productScores.rich = (productScores.rich || 0) + 0.20;
        break;
    }
  }
  
  // Afficher scores finaux
  console.log('\n========================================');
  console.log('=== SCORES FINAUX (après tous les boosts) ===');
  console.log('========================================');
  for (const product of ALL_PRODUCTS) {
    console.log(`${product.toUpperCase().padEnd(10)}: ${(productScores[product] * 100).toFixed(1)}%`);
  }
  
  // Trouver le produit avec le score le plus élevé
  let bestProduct = 'rich';
  let bestScore = -Infinity;
  
  for (const product of ALL_PRODUCTS) {
    if (productScores[product] > bestScore) {
      bestScore = productScores[product];
      bestProduct = product;
    }
  }
  
  console.log('\n========================================');
  console.log('=== RÉSULTAT FINAL ===');
  console.log('========================================');
  console.log(`🏆 Gagnant: ${bestProduct.toUpperCase()} avec ${(bestScore * 100).toFixed(1)}%`);
  console.log('========================================\n\n');
  
  // Si aucun score significatif, retourner le coffret
  if (bestScore <= 0.1) {
    console.log('⚠️ Score trop faible, retour par défaut au Coffret RICH');
    return 'rich';
  }
  
  return bestProduct;
}

// Afficher le résultat
function showResult() {
  const recommended = calculateRecommendation();
  const perfume = perfumes[recommended];
  
  const content = document.getElementById('lawson-quiz-content');
  
  const html = `
    <div class="lawson-quiz-result fade-in">
      <h3 class="lawson-quiz-result-title">Votre parfum signature</h3>
      <h2 class="lawson-quiz-result-name">${perfume.name}</h2>
      <p class="lawson-quiz-result-tagline">${perfume.tagline}</p>
      
      <div class="lawson-quiz-result-image">
        <img src="${perfume.image}" alt="${perfume.name}" onerror="this.style.display='none'">
      </div>
      
      <p class="lawson-quiz-result-description">${perfume.description}</p>
      
      <div class="lawson-quiz-result-actions">
        <a href="${perfume.url}" class="lawson-quiz-btn lawson-quiz-btn-primary-gold">
          Découvrir ${perfume.name}
        </a>
        <button onclick="openQuiz()" class="lawson-quiz-btn lawson-quiz-btn-secondary">
          Refaire le quiz
        </button>
      </div>
    </div>
  `;
  
  content.innerHTML = html;
  
  document.querySelector('.lawson-quiz-navigation').style.display = 'none';
  document.querySelector('.lawson-quiz-progress-container').style.display = 'none';
  document.getElementById('lawson-quiz-step').style.display = 'none';
}

// Initialiser le quiz au chargement de la page
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initQuiz);
} else {
  initQuiz();
}